import axios from 'axios';

const state = {
    wards: [],
    wardLists: [],
    rows: 1,
    perPage: 10,
    meta: {},
};

const getters = {
    wards: state =>{
        return state.wards;
    },
    wardLists: state =>{
        return state.wardLists;
    },
    rows: state => {
        return state.rows;
    },
    perPage: state => {
        return state.perPage;
    },
    meta: state => {
        return state.meta;
    },
};

const actions = {
    getWards({commit, dispatch}, filter){
        dispatch('Settings/loading', true,{root:true});
        try {
            axios
                .get(`/admin/wards?page=${filter.currentPage}&sortBy=${filter.sortBy}&sortOrder=${filter.sortOrder}`)
                .then((res) => {

                    commit('setWards', res.data.data);
                    commit('setRows', Math.ceil(
                        res.data.meta.total / res.data.meta.per_page
                    ))
                    commit('setPerPage', parseInt(res.data.meta.per_page))
                    commit('SET_META', res.data.meta)
                    dispatch('Settings/loading', false, { root: true });
                })
                .catch((err) => {
                    console.log(err);
                    dispatch('Settings/loading', false,{root:true});
                });
        } catch (err) {
            console.log(err);
            dispatch('Settings/loading', false,{root:true});
        }

    },
    getWardLists({commit, dispatch}, currentPage){
        dispatch('Settings/loading', true,{root:true});
        try {
            axios
                .get(`/admin/wards/lists?page=${currentPage  ? currentPage : '1'}`)
                .then((res) => {

                    commit('setWardLists', res.data.data);
                    dispatch('Settings/loading', false, { root: true });
                })
                .catch((err) => {
                    console.log(err);
                    dispatch('Settings/loading', false,{root:true});
                });
        } catch (err) {
            console.log(err);
            dispatch('Settings/loading', false,{root:true});
        }

    },
    storeWard({commit}, payload){
        return axios
            .post(`/admin/wards`, payload)
            .then((res) => {
                commit('updateWardsList', res.data.data);
            });
    },

    updateWard({commit}, ward){
        return axios
            .put(`/admin/wards/${ward.id}`, ward)
            .then((res) => {
                commit('updateEditedWard', res.data.data);
            });
    },
    destroy({ commit }, id) {
        return axios.delete(`/admin/wards/${id}`).then((res) => {
            commit("DELETE_NOTICE", id);
            return res;
        });
    },
};

const mutations = {
    setWards(state, wards){
        state.wards = wards;
    },
    setWardLists(state, wards){
        state.wardLists = wards;
    },
    updateWardsList(state, ward){
        state.wards.unshift(ward);
    },
    updateEditedWard(state, ward){
        state.wards.map((item,index)=>{
            if(item.id == ward.id){
                state.wards[index] = ward;
            }
        });
    },
    DELETE_NOTICE(state, id) {
        const i = state.wards.map((item) => item.id).indexOf(id);
        state.wards.splice(i, 1);
    },
    setRows(state, rows) {
        state.rows = rows;
    },
    setPerPage(state, perPage) {
        state.perPage = perPage;
    },
    SET_META(state, meta) {
        state.meta = meta;
    },
};

export default {
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}
